export const NAMESPACE = 'jbp-financial-plan-quality'

export const TRANSLATION_KEYS = {
  tab: {
    title: `${NAMESPACE}-tab-title`,
    titleReqs: `${NAMESPACE}-tab-title-reqs`,
  },

  quality: {
    title: `${NAMESPACE}-title`,
    subtitle: `${NAMESPACE}-subtitle`,

    overall: {
      score: `${NAMESPACE}-overall-score`,
    },

    financialGrowth: {
      title: `${NAMESPACE}-financial-growth-title`,
      description: `${NAMESPACE}-financial-growth-description`,
    },

    sobGrowth: {
      title: `${NAMESPACE}-sob-growth-title`,
      description: `${NAMESPACE}-sob-growth-description`,
    },

    actions: {
      howWeScore: `${NAMESPACE}-actions-how-we-score`,
      showDetails: `${NAMESPACE}-actions-show-details`,
      hideDetails: `${NAMESPACE}-actions-hide-details`,
      goToPlanning: `${NAMESPACE}-actions-go-to-planning`,
    },

    details: {
      category: `${NAMESPACE}-details-category`,
      plannedYoY: `${NAMESPACE}-details-planned-yoy`,
      marketTarget: `${NAMESPACE}-details-market-target`,
      points: `${NAMESPACE}-details-points`,
      band: `${NAMESPACE}-details-band`,
    },

    scoreInfo: {
      title: `${NAMESPACE}-score-info-title`,
      description: `${NAMESPACE}-score-info-description`,
      low: `${NAMESPACE}-score-info-low`,
      moderate: `${NAMESPACE}-score-info-moderate`,
      high: `${NAMESPACE}-score-info-high`,
    },
  },

  requirements: {
    intro: `${NAMESPACE}-requirements-intro`,
    whatWeScore: `${NAMESPACE}-requirements-what-we-score`,

    low: `${NAMESPACE}-requirements-low`,
    moderate: `${NAMESPACE}-requirements-moderate`,
    high: `${NAMESPACE}-requirements-high`,

    financialGrowth: {
      title: `${NAMESPACE}-requirements-financial-growth-title`,
      description: `${NAMESPACE}-requirements-financial-growth-description`,
    },

    sobGrowth: {
      title: `${NAMESPACE}-requirements-sob-growth-title`,
      description: `${NAMESPACE}-requirements-sob-growth-description`,
    },

    getStarted: `${NAMESPACE}-requirements-get-started`,

    completeFinPlan: {
      title: `${NAMESPACE}-requirements-complete-fin-plan-title`,
      description: `${NAMESPACE}-requirements-complete-fin-plan-description`,
    },
  },
}
